import { useState } from 'react';

export function useCursorPagination<C = string>() {
  const [cursor, setCursor] = useState<C | undefined>(undefined);
  const [history, setHistory] = useState<C[]>([]);

  const goNext = (nextCursor: C) => {
    if (cursor !== undefined) setHistory((h) => [...h, cursor]);
    setCursor(nextCursor);
  };

  const goPrev = () => {
    const prev = history[history.length - 1];
    setHistory((h) => h.slice(0, -1));
    setCursor(prev);
  };

  const reset = () => {
    setCursor(undefined);
    setHistory([]);
  };

  return { cursor, hasPrev: history.length > 0, goNext, goPrev, reset };
}
